import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/SearchBar.css';

function Searchbar() {
    const [query, setQuery] = useState('');
    const [searchHistory, setSearchHistory] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const savedHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
        setSearchHistory(savedHistory);
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim()) {
            // Remove duplicates and add the new query
            const updatedHistory = [query, ...searchHistory]
                .filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates
                .slice(0, 5); // Keep only the last 5 searches
            
            localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));
            setSearchHistory(updatedHistory);

            navigate(`/catalog?search=${encodeURIComponent(query)}`);
        }
    };

    return (
        <div className="search-bar">
            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Hľadať..."
                    aria-label="Search"
                    list="search-history"
                />
                <datalist id="search-history">
                    {searchHistory.map((item, index) => (
                        <option key={index} value={item} />
                    ))}
                </datalist>
                <button type="submit"><i className="fas fa-magnifying-glass"></i></button>
            </form>
        </div>
    );
}

export default Searchbar;
